<template>
    <div class="doctor-recommendation">
        <p class="panel-title">Top10 医生推荐</p>
        <el-tabs v-if="doctors.length" v-model="activeDoctor">
            <el-tab-pane v-for="(doctor, index) in doctors" :key="index" :label="doctor.name" :name="String(index)" />
        </el-tabs>
        <div class="graph-card">
            <p class="panel-title">{{ graphTitle }}</p>
            <knowledge-graph :key="activeDoctor" :graph-data="graphData" :title="graphTitle" height="420px" />
        </div>
    </div>
</template>
<script>
import KnowledgeGraph from './knowledge_graph.vue';
export default {
    name: 'DoctorRecommendation',
    components: { KnowledgeGraph },
    props: { doctors: { type: Array, default: () => [] } },
    data() { return { activeDoctor: '0' }; },
    computed: {
        selectedDoctor() { return this.doctors[Number(this.activeDoctor)]; },
        graphTitle() { return this.selectedDoctor ? this.selectedDoctor.name + '知识图谱' : '医生推荐知识图谱'; },
        graphData() { return (this.selectedDoctor && this.selectedDoctor.result) || { nodes: [], edges: [] }; },
    },
    watch: { doctors() { this.activeDoctor = '0'; } },
};
</script>
<style lang="less" scoped>
.panel-title { margin: 0 0 12px; font-size: 14px; font-weight: bold; color: #0C55AA; line-height: 20px; }
.graph-card { padding: 14px; background: #fff; border: 1px solid #E8EEF8; border-radius: 10px; }
</style>
